import MUIDataTable from "mui-datatables";

// Common MUI DataTable options
export const getCommonTableOptions = (customOptions = {}) => ({
    responsive: "standard",
    selectableRows: "none",
    filter: true,
    sort: true,
    rowsPerPage: 250,
    rowsPerPageOptions: [50, 100, 250, 500, 1000],
    print: false,
    download: false,
    search: true,
    columnOrder: null,
    fixedHeader: false,
    ...customOptions,
});

// Common table wrapper component
export const TableWrapper = ({ data, columns, options, loading }) => {
    if (!data) {
        return <h3 className="px-2 pt-8 text-center">{loading || "Loading..."}</h3>;
    }

    return (
        <div className="flex w-full flex-col">
            <MUIDataTable data={data} columns={columns} options={options} className="ngShadow" />
        </div>
    );
};

// Add to existing TableConfig.js
export const TABLE_PRESETS = {
    DEFAULT: {
        filter: true,
        sort: true,
        search: true,
    },
    METRICS: {
        filter: false,
        sort: false,
        search: false,
        pagination: false,
        fixedHeader: true,
    },
    CARR: {
        filter: false,
        sort: false,
        viewColumns: false,
        pagination: false,
    },
};

export const getTableOptions = (preset = "DEFAULT", customOptions = {}) =>
    getCommonTableOptions({ ...TABLE_PRESETS[preset], ...customOptions });
